import { MAP_LAYER_FACTS } from '@/api/rest/resources/types/fact';
import { DEFAULT_LAYER_OPACITY, useControlsContext } from '@/components/widgets/o/Map/hooks/useFormControls';

export const useLayerOpacity = (layer: MAP_LAYER_FACTS | string) => {
  const controlsForm = useControlsContext();
  const opacityValuesByLayer = controlsForm.watch('layerOpacity');
  const opacityValue = opacityValuesByLayer?.[layer as MAP_LAYER_FACTS] ?? DEFAULT_LAYER_OPACITY;

  return opacityValue / 100;
};
